import React from "react";
import OfficeDesktopLayout from "views/components/OfficeDesktopLayout";
import { TicketDetail } from "../../../components/Ticket/TicketDetail";

export const TicketDetailView = ({
	user,
	office,
	line,
	...ticketDetailProps
}) => {
	return (
		<OfficeDesktopLayout user={user} office={office} title={line.name}>
			{line && (
				<TicketDetail
					office={office}
					line={line}
					{...ticketDetailProps}
				></TicketDetail>
			)}
		</OfficeDesktopLayout>
	);
};
